/*
 * Builds the bulk catalogue PDF in the browser.
 *
 * The product data is rendered into the page by sections/b2b-cta.liquid and is
 * limited to buyer-facing fields (name, pack sizes, price, link). No cost
 * price, margin, stock level, SKU, barcode or vendor is ever written into the
 * page, so none of it can reach the PDF.
 *
 * jsPDF is fetched from the CDN only when the button is actually pressed, so
 * the library costs nothing on a normal page view.
 */
(function () {
  var JSPDF_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
  var GREEN = [26, 94, 51];
  var loader = null;

  function loadJsPdf() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve();
    if (loader) return loader;
    loader = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = JSPDF_SRC;
      s.async = true;
      s.onload = function () {
        if (window.jspdf && window.jspdf.jsPDF) resolve();
        else reject(new Error('jsPDF unavailable'));
      };
      s.onerror = function () {
        loader = null;
        reject(new Error('Could not load the PDF library'));
      };
      document.head.appendChild(s);
    });
    return loader;
  }

  function today() {
    try {
      return new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return new Date().toDateString();
    }
  }

  function slug(text) {
    return String(text || 'catalogue')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 40);
  }

  function build(data) {
    var JsPDF = window.jspdf.jsPDF;
    var doc = new JsPDF({ unit: 'pt', format: 'a4' });
    var pageW = doc.internal.pageSize.getWidth();
    var pageH = doc.internal.pageSize.getHeight();

    var margin = 42;
    var bodyW = pageW - margin * 2;
    var colProduct = bodyW * 0.46;
    var colPack = bodyW * 0.32;
    var colPrice = bodyW * 0.22;
    var xProduct = margin;
    var xPack = margin + colProduct;
    var xPriceRight = margin + bodyW;
    var y = 0;

    function header() {
      doc.setFillColor(GREEN[0], GREEN[1], GREEN[2]);
      doc.rect(0, 0, pageW, 92, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(20);
      doc.text(String(data.shop || 'Bulk Catalogue'), margin, 42);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
      doc.text(String(data.title || ''), margin, 64);
      doc.text('Generated ' + today(), pageW - margin, 64, { align: 'right' });
      y = 124;
    }

    function tableHead() {
      doc.setFillColor(240, 247, 242);
      doc.rect(margin, y - 14, bodyW, 24, 'F');
      doc.setTextColor(GREEN[0], GREEN[1], GREEN[2]);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text('PRODUCT', xProduct + 6, y + 2);
      doc.text('PACK SIZES', xPack + 6, y + 2);
      doc.text('PRICE', xPriceRight - 6, y + 2, { align: 'right' });
      y += 24;
    }

    function footers() {
      var total = doc.internal.getNumberOfPages();
      for (var p = 1; p <= total; p++) {
        doc.setPage(p);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        if (data.note) {
          doc.text(String(data.note), margin, pageH - 26, { maxWidth: bodyW - 90 });
        }
        doc.text('Page ' + p + ' of ' + total, pageW - margin, pageH - 26, { align: 'right' });
      }
    }

    header();
    tableHead();

    var items = Array.isArray(data.items) ? data.items : [];

    if (!items.length) {
      doc.setTextColor(60, 60, 60);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
      doc.text('No products are currently listed in this catalogue.', margin, y + 10);
      footers();
      return doc;
    }

    doc.setFontSize(10);

    items.forEach(function (item, index) {
      var nameLines = doc.splitTextToSize(String(item.name || ''), colProduct - 12);
      var packLines = doc.splitTextToSize(String(item.pack || ''), colPack - 12);
      var lines = Math.max(nameLines.length, packLines.length, 1);
      var rowH = lines * 13 + 14;

      // Start a new page before a row would run off the bottom.
      if (y + rowH > pageH - 56) {
        doc.addPage();
        header();
        tableHead();
        doc.setFontSize(10);
      }

      if (index % 2 === 1) {
        doc.setFillColor(250, 250, 250);
        doc.rect(margin, y - 10, bodyW, rowH, 'F');
      }

      doc.setTextColor(30, 30, 30);
      doc.setFont('helvetica', 'bold');
      doc.text(nameLines, xProduct + 6, y + 2);

      doc.setFont('helvetica', 'normal');
      doc.setTextColor(90, 90, 90);
      doc.text(packLines, xPack + 6, y + 2);

      doc.setTextColor(GREEN[0], GREEN[1], GREEN[2]);
      doc.setFont('helvetica', 'bold');
      doc.text(String(item.price || ''), xPriceRight - 6, y + 2, { align: 'right' });

      y += rowH;

      doc.setDrawColor(226, 232, 228);
      doc.setLineWidth(0.5);
      doc.line(margin, y - 8, margin + bodyW, y - 8);
    });

    footers();
    return doc;
  }

  function wire(button) {
    if (button.dataset.b2bCatalogBound === 'true') return;
    button.dataset.b2bCatalogBound = 'true';

    var root = button.closest('[data-b2b-cta]') || document;
    var payloadEl = root.querySelector('[data-b2b-catalog]');
    var statusEl = root.querySelector('[data-b2b-catalog-status]');
    var idle = button.dataset.idleLabel || button.textContent.trim();

    function say(message) {
      if (statusEl) statusEl.textContent = message || '';
    }

    button.addEventListener('click', function () {
      if (button.getAttribute('aria-busy') === 'true') return;

      var data;
      try {
        data = JSON.parse(payloadEl ? payloadEl.textContent : '{}');
      } catch (e) {
        say('The catalogue could not be read. Please refresh and try again.');
        return;
      }

      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.busyLabel || 'Preparing PDF...';
      say('');

      loadJsPdf()
        .then(function () {
          var doc = build(data);
          var name = slug(data.shop) + '-' + slug(data.title) + '.pdf';
          doc.save(name);
          say('');
        })
        .catch(function () {
          say('The catalogue could not be generated just now. Please try again, or contact us and we will email it over.');
        })
        .then(function () {
          button.removeAttribute('aria-busy');
          button.textContent = idle;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-b2b-catalog-download]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', init);
})();
